/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useEffect, useState } from 'react'
import DeleteDataModal from '../DeleteDataModal'
import { useParams } from 'react-router-dom'
import EditDataModal from '../EditDataModal'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAssetsBatchDataByBatch, getAssetsBatchDataByBatchAsCsv } from '@/services/asset-batches'
import DefaultCrudTable from '@/components/tables/DefaultCrudTable'
import CustomTableBody from './components/CustomTableBody'
import { columnsFileFromCsv } from '../../../../handlers'
import { Box } from '@chakra-ui/react'
import DownloadFileButton from '@/components/buttons/DownloadFileButton'
import { EXPORT_CSV } from '@/configs/strings/listings'

const QueuedFilesTable = ({ setTotalQueueData }) => {
  const { batchId } = useParams()
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    reloadItems,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getAssetsBatchDataByBatch,
    fetchParams: { id: batchId }
  })
  useEffect(() => {
    setTotalQueueData(itemsResponse?.total)
  }, [itemsResponse?.total])

  const [editModalIsOpen, setEditModalIsOpen] = useState(false)
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false)
  const [currentIds, setCurrentIds] = useState()
  const [selectedData, setSelectedData] = useState()
  const handleOpenDeleteModal = (dataId) => {
    setEditModalIsOpen(false)
    setDeleteModalIsOpen(true)
    setCurrentIds({ batchId, dataId })
  }
  const handleOpenEditModal = (data) => {
    setDeleteModalIsOpen(false)
    setEditModalIsOpen(true)
    setCurrentIds({ batchId, dataId: data.id })
    setSelectedData(data)
  }
  const onCloseEditModal = () => {
    reloadItems()
    setEditModalIsOpen(false)
  }
  const onCloseDeleteModal = () => {
    reloadItems()
    setDeleteModalIsOpen(false)
  }
  return (
    <>
      { editModalIsOpen &&
        <EditDataModal
          batchId={currentIds.batchId}
          dataId={currentIds.dataId}
          onClose={onCloseEditModal}
          data={selectedData}
        />
      }
      { deleteModalIsOpen &&
        <DeleteDataModal
          batchId={currentIds.batchId}
          dataId={currentIds.dataId}
          onClose={onCloseDeleteModal}
        />
      }
      <section className="mb-md">
        <h2 className="mb-4">
          + Queued Files from CSV ({ itemsResponse?.total })
        </h2>
        <Box mb="4">
          <DownloadFileButton
            service={
              (getAccessToken) =>
                getAssetsBatchDataByBatchAsCsv({ id: batchId }, getAccessToken)
            }
            isDisabled={!itemsResponse?.data.length}
              dataKey="csv"
          >
            { EXPORT_CSV }
          </DownloadFileButton>
        </Box>
        <DefaultCrudTable
          page={page}
          totalPages={totalPages}
          onPageChange={(page) => onChangePage(page)}
        >
          <DefaultCrudTable.Header
            columns={columnsFileFromCsv}
          />
          <CustomTableBody
            loading={loading}
            columns={columnsFileFromCsv}
            items={itemsResponse?.data}
            onEdit={handleOpenEditModal}
            onDelete={handleOpenDeleteModal}
          />
        </DefaultCrudTable>
      </section>
    </>
  )
}

export default QueuedFilesTable
